import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { printPlugin } from "@react-pdf-viewer/print";
import { highlightPlugin, Trigger } from "@react-pdf-viewer/highlight";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/highlight/lib/styles/index.css";
// Import styles
import "@react-pdf-viewer/print/lib/styles/index.css";
import "./index.css";
import CircularProgressWithLabel from "../CircularProgressWithLabel";
import { getFilePlugin } from "@react-pdf-viewer/get-file";

function PDFViewWithMultiplePagesHighlighted({
  citations,
  fileUrl,
  scale = 1,
  handlePagesChange,
  zoomPluginInstance,
  pageNavigationPluginInstance,
  printPluginInstance = printPlugin(),
  getFilePluginInstance = getFilePlugin(),
}) {
  const [isFileLoading, setIsFileLoading] = useState(true);
  const { jumpToPage } = pageNavigationPluginInstance;
  const [areas, setAreas] = useState([]);

  const pageLayout = {
    transformSize: ({ size }) => ({
      height: size.height + 8,
      width: size.width + 8,
    }),
  };

  // Reset loading state whenever the file URL changes so we wait to jump
  useEffect(() => {
    if (fileUrl) {
      setIsFileLoading(true);
    }
  }, [fileUrl]);

  useEffect(() => {
    if (!citations || citations.length === 0) return;

    const newAreas = citations.map((citation) => {
      let parsedCoordinates = [5, 5, 90, 90];
      try {
        parsedCoordinates = JSON.parse(citation.coordinates);
      } catch (error) {
        console.log(error);
      }
      return {
        pageIndex: citation.page - 1,
        height: parsedCoordinates[3],
        width: parsedCoordinates[2],
        left: parsedCoordinates[0],
        top: parsedCoordinates[1],
      };
    });
    setAreas(newAreas);

    // Only jump after the document has loaded to avoid being reset to page 1
    if (!isFileLoading) {
      jumpToPage(citations[0].page - 1);
    }
  }, [isFileLoading, citations]);

  const renderHighlights = (props) => (
    <div>
      {areas
        .filter((area) => area.pageIndex === props.pageIndex)
        .map((area, idx) => (
          <div
            key={idx}
            className="highlight-area"
            style={Object.assign(
              {},
              {
                background: "#b4d7ff",
                opacity: 0.3,
              },
              props.getCssProperties(area, props.rotation)
            )}
          />
        ))}
    </div>
  );

  const highlightPluginInstance = highlightPlugin({
    renderHighlights,
    trigger: Trigger.None,
  });

  const handleDocumentLoad = (e) => {
    if (handlePagesChange) handlePagesChange(e.doc.numPages);
    setIsFileLoading(false);
  };

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      <Viewer
        onDocumentLoad={handleDocumentLoad}
        plugins={[
          highlightPluginInstance,
          pageNavigationPluginInstance,
          zoomPluginInstance,
          printPluginInstance,
          getFilePluginInstance,
        ]}
        defaultScale={scale}
        fileUrl={fileUrl}
        pageLayout={pageLayout}
        renderLoader={(percentages) => (
          <CircularProgressWithLabel value={Math.round(percentages)} />
        )}
      />
    </Worker>
  );
}

export default PDFViewWithMultiplePagesHighlighted;
